export const LOGO = "https://customer-assets-7cd3h4nn.emergentagent.net/job_potion-garden-market/artifacts/5uo3nftf_logo%20bigliettini%203.5x3.5.png";
export const BANNER = "https://customer-assets-7cd3h4nn.emergentagent.net/job_potion-garden-market/artifacts/tz6r66bo_bigliettini%20da%20visita%20fronte%208x5.png";
